import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEven, isNullOrUndefinedOrEmpty } from "base/utils";
import { RecipeContext } from "components/recipe/providers/RecipeProvider";
import { formatQuantity, quantityOptions } from "./utils";
import FormAutoComplete from "base/FormAutoComplete";
import React, { useContext, useEffect, useState } from "react";

const AddIngredient = ({ index, ingredient, ingredients, onAdd, onRemove }) => {
  const { measurements } = useContext(RecipeContext);
  const [measurement, setMeasurement] = useState("");
  const [quantity, setQuantity] = useState("");
  const [name, setName] = useState("");

  const removeIngredient = () => {
    onRemove();
  };

  const handleMeasurementUpdate = (val) => {
    setMeasurement(val?.abbreviation || val);
  };

  const handleQuantityUpdate = (val) => {
    setQuantity(val);
  };

  const handleNameUpdate = (val) => {
    setName(val);
  };

  useEffect(() => {
    if (
      !isNullOrUndefinedOrEmpty(measurement) ||
      !isNullOrUndefinedOrEmpty(quantity) ||
      !isNullOrUndefinedOrEmpty(name)
    ) {
      onAdd({
        id: ingredient.id,
        measurement,
        name,
        quantity,
        sort_order: index,
      });
    }
  }, [measurement, quantity, name, ingredient.id, index]);

  return (
    <div
      className={`Column p-10 ${isEven(index) ? "even" : "odd"}`}
      key={ingredient.id}
    >
      <div className="Row Space-B">
        <div className="m-width-80">
        </div>
        <button
          type="button"
          className="Delete-Icon"
          onClick={removeIngredient}
          aria-label="Remove ingredient"
        >
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="Row">
        <FormAutoComplete
          fieldLabel="Ingredient"
          formClass="w-100"
          listOptions={ingredients}
          onChange={handleNameUpdate}
          placeholder="Ingredient"
        />
      </div>
      <div className="Row">
        <FormAutoComplete
          fieldLabel="Quantity"
          // Text permits fractions, mixed fractions, and decimals.
          fieldType="text"
          formClass="w-50 mr-10"
          listOptions={quantityOptions}
          // saved value remains the original fraction string.
          formatOptionLabel={formatQuantity}
          value={quantity}
          onChange={handleQuantityUpdate}
          placeholder="Quantity"
        />
        <FormAutoComplete
          fieldLabel="Measurement"
          formClass="w-50 mr-10"
          listOptions={measurements}
          onChange={handleMeasurementUpdate}
          placeholder="Measurement"
          returnFullObject
        />
      </div>
    </div>
  );
};

export default AddIngredient;
